import PropTypes from 'prop-types';
import { Nav } from 'react-bootstrap';
import classNames from 'classnames';
import { useAuth } from '../../context/AuthContext';
import { hasAnyPermission, hasPermission, PERMISSION_IDS } from '../../utils/permissions';
import './AdminSidebar.css';

const navItems = [
  { 
    eventKey: 'dashboard', 
    label: 'Dashboard', 
    icon: 'bi-speedometer2', 
    path: '/admin',
    permissionId: PERMISSION_IDS.PANEL_ADMIN,
  },
  { 
    eventKey: 'users', 
    label: 'Usuarios', 
    icon: 'bi-people', 
    path: '/admin/users',
    permissionId: PERMISSION_IDS.VER_USUARIOS,
  },
  { 
    eventKey: 'roles', 
    label: 'Roles', 
    icon: 'bi-shield-check', 
    path: '/admin/roles',
    permissionIds: [
      PERMISSION_IDS.VER_ROLES,
      PERMISSION_IDS.CREAR_ROLES,
      PERMISSION_IDS.EDITAR_ROLES,
      PERMISSION_IDS.ELIMINAR_ROLES,
    ],
  },
  { 
    eventKey: 'courses', 
    label: 'Cursos', 
    icon: 'bi-mortarboard', 
    path: '/admin/courses',
    permissionId: PERMISSION_IDS.VER_PANEL_CURSOS,
  },
  { 
    eventKey: 'events', 
    label: 'Eventos', 
    icon: 'bi-calendar3', 
    path: '/admin/events',
    permissionId: PERMISSION_IDS.PANEL_EVENTOS,
  },
  { 
    eventKey: 'items', 
    label: 'Items', 
    icon: 'bi-box-seam', 
    path: '/admin/items',
    permissionId: PERMISSION_IDS.PANEL_ITEMS,
  },
  { 
    eventKey: 'asesorias', 
    label: 'Asesorías', 
    icon: 'bi-chat-dots', 
    path: '/admin/asesorias',
    permissionId: PERMISSION_IDS.PANEL_ASESORIAS,
  },
  { 
    eventKey: 'profesores', 
    label: 'Profesores', 
    icon: 'bi-person-badge', 
    path: '/admin/profesores',
    permissionId: PERMISSION_IDS.VER_PROFESORES,
  },
  { 
    eventKey: 'newsletters', 
    label: 'Newsletters', 
    icon: 'bi-envelope-paper', 
    path: '/admin/newsletters',
    permissionId: PERMISSION_IDS.PANEL_NEWSLETTER,
  },
  { 
    eventKey: 'pruebas', 
    label: 'Pruebas', 
    icon: 'bi-flask', 
    path: '/admin/pruebas',
    permissionId: PERMISSION_IDS.TESTER,
  },
  { 
    eventKey: 'mailing', 
    label: 'Mailing', 
    icon: 'bi-envelope-at', 
    path: '/admin/mailing',
    permissionId: PERMISSION_IDS.PANEL_MAILING,
  },
  { 
    eventKey: 'products', 
    label: 'Productos', 
    icon: 'bi-cart', 
    path: '/admin/products',
    permissionId: PERMISSION_IDS.PANEL_PRODUCTOS,
  },
  { 
    eventKey: 'orders', 
    label: 'Pedidos', 
    icon: 'bi-bag-check', 
    path: '/admin/orders',
    permissionId: PERMISSION_IDS.VER_PEDIDOS,
  },
  { 
    eventKey: 'reports', 
    label: 'Reportes', 
    icon: 'bi-bar-chart', 
    path: '/admin/reports',
    permissionIds: [
      PERMISSION_IDS.PANEL_REPORTES,
      PERMISSION_IDS.VER_REPORTES,
      PERMISSION_IDS.PANEL_ADMIN,
    ],
  },
];

const AdminSidebar = ({ activeKey = 'dashboard', onNavigate }) => {
  const { user } = useAuth();

  // Filtrar items según permisos; sin ID válido no se muestra (evita exponer secciones por error)
  const visibleItems = navItems.filter((item) => {
    if (Array.isArray(item.permissionIds) && item.permissionIds.length > 0) {
      const valid = item.permissionIds.every((id) => typeof id === 'number' && !Number.isNaN(id));
      if (!valid) return false;
      return hasAnyPermission(user, item.permissionIds);
    }
    const id = item.permissionId;
    if (typeof id !== 'number' || Number.isNaN(id)) return false;
    return hasPermission(user, id);
  });

  return (
    <aside className="admin-sidebar d-flex flex-column">
      <div className="sidebar-header px-4 py-4">
        <h2 className="sidebar-title mb-0 text-white">Panel Admin</h2>
        <p className="sidebar-subtitle text-white-50 mb-0">Gestión integral</p>
      </div>
      <div className="sidebar-nav-container">
        <Nav className="flex-column px-2 py-3 gap-1" variant="pills" activeKey={activeKey}>
          {visibleItems.map((item) => (
            <Nav.Item key={item.eventKey}>
              <Nav.Link
                eventKey={item.eventKey}
                onClick={() => onNavigate?.(item)}
                className={classNames('d-flex align-items-center gap-2 sidebar-link', {
                  active: activeKey === item.eventKey,
                })}
              >
                <i className={`bi ${item.icon} fs-5`} />
                <span className="fw-semibold">{item.label}</span>
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </div>
    </aside>
  );
};

AdminSidebar.propTypes = {
  activeKey: PropTypes.string,
  onNavigate: PropTypes.func,
};

export default AdminSidebar;

